module.exports = __webpack_public_path__ + "img/handwritten-postcard-full.777bd1b9.png";